










































































































































































import { defineComponent, inject, computed } from '@vue/composition-api'

// Store
import { StoreKey as ErrorStoreKey } from '@/store/Error'

export default defineComponent({
    setup() {
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }

        const hasError = computed(() => {
            return (
                (errorStore.name.value && errorStore.name.value.length) ||
                (errorStore.tel.value && errorStore.tel.value.length) ||
                (errorStore.email.value && errorStore.email.value.length) ||
                (errorStore.zip.value && errorStore.zip.value.length) ||
                (errorStore.address.value && errorStore.address.value.length) ||
                (errorStore.construction.value &&
                    errorStore.construction.value.length) ||
                (errorStore.howto.value && errorStore.howto.value.length) ||
                (errorStore.ipad.value && errorStore.ipad.value.length) ||
                (errorStore.shop.value && errorStore.shop.value.length) ||
                (errorStore.shop_other.value &&
                    errorStore.shop_other.value.length) ||
                (errorStore.date.value && errorStore.date.value.length) ||
                (errorStore.time.value && errorStore.time.value.length) ||
                (errorStore.question.value &&
                    errorStore.question.value.length) ||
                (errorStore.important.value &&
                    errorStore.important.value.length) ||
                (errorStore.request1.value &&
                    errorStore.request1.value.length) ||
                (errorStore.request2.value &&
                    errorStore.request2.value.length) ||
                (errorStore.request3.value &&
                    errorStore.request3.value.length) ||
                (errorStore.request_other.value &&
                    errorStore.request_other.value.length) ||
                (errorStore.privacy.value && errorStore.privacy.value.length)
            )
        })

        return {
            errorStore,
            hasError,
        }
    },
})
